import { createTheme } from "@material-ui/core";

const theme = createTheme({
    typography: {
        fontFamily: ["GT-America", '"Segoe UI"', "Roboto"].join(","),
    },
    palette: {
        primary: {
            main: "#456BD9",
        },
        grey: {
            800: "#3E3E3E",
        },
    },
});

export const darkTheme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#000000",
        },
        info: {
            main: "#456BD9",
        },
    },
    typography: {
        fontFamily: [
            '"GTAmericaRegular"',
            '"GTAmericaMedium"',
            '"GTAmericaBold"',
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
    },
});
export default theme;
